const DEFAULT_LINK_ATTRS = { line: { strokeDasharray: 0, stroke: '#888888' } };
const LINKS_ATTRS_MAPPING = {
  bagage_bac: { line: { strokeDasharray: 0, stroke: '#5555ff' } },
  bagage_cru: { line: { strokeDasharray: 0, stroke: '#77dd88' } },
  bac_vide: { line: { strokeDasharray: 5.5, stroke: '#99dddd' } },
};

export const getAttrsByLinkType = (linkType) => LINKS_ATTRS_MAPPING[linkType] ?? DEFAULT_LINK_ATTRS;
